<section class="content">

  <div class="row" *ngIf="toggle">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            <div class="input-group input-group-sm" style="width: 250px;">

              <div class="input-group-append">
                <button type="submit" class="btn btn-default" id="btn" (click)="back();">
                  <i class="fas fa-create"></i> Add New Lead
                </button>
              </div>

              <div class="input-group-append">
                <button type="submit" class="btn btn-default" (click)="export()">Export
                  <i class="fas fa-download"></i>
                </button>
              </div>
            </div>

          </div>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 300px;">
              <input type="text" name="table_search" [(ngModel)]="searchString" class="form-control float-right"
                placeholder="Search">

              <div class="input-group-append">
                <button type="submit" class="btn btn-default">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
        <div class="card-body table-responsive p-0" style="height: 410px;">
          <table class="table table-head-fixed text-nowrap" #assetsTable>
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Contact</th>
                <th>Sales Officer</th>
                <th></th>
              </tr>
            </thead>
            <tbody *ngIf="!isloading && leads.length > 0">
              <tr *ngFor="let lead of leads | filter: searchString: '' ">
                <td>{{ lead.name}}</td>
                <td>{{ lead.contact_1 }}</td>
                <td>{{ lead.sale_person?.name }}</td>
                <td>
                  <a class="btn" (click)="edit(lead)"><i class="fas fa-edit"></i></a>
                  <a class="btn" (click)="info(lead)"><i class="fas fa-info"></i></a>
                  <a class="btn" (click)="delete(lead)"
                  *ngIf="currentUser.role === 'admin' || currentUser.role === 'manager' ">
                    <i class="fas fa-trash"></i></a>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="isloading">
              <td class="text-center" colspan="4">loading ...</td>
            </tbody>
            <tbody *ngIf="!isloading && leads.length == 0">
              <td class="text-center" colspan="4">No lead</td>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="leadForm" (ngSubmit)="onSubmit();" autocomplete="off" *ngIf="!toggle">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-primary">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fa fa-arrow-left" style="margin-right: 8px;" (click)="back()"></i>
              Manage lead
            </h3>
          </div>
          <div class="card-body" style="display: block;">
            <div class="form-group">
              <label for="name">Customer Name</label>
              <input type="text" id="name" class="form-control" formControlName="name" required>
              <p *ngIf="leadForm.get('name').invalid" class="error">*name is required</p>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="contact">Contact Number</label>
                <input type="tel" id="contact" class="form-control" formControlName="contact_1">
                <p *ngIf="leadForm.get('contact_1').invalid" class="error">*contact number is required</p>
              </div>
              <div class="form-group col-md-6">
                <label for="alternate contact">Alternate Contact Number</label>
                <input type="tel" id="alternate contact" class="form-control" formControlName="contact_2">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="email">Email</label>
                <input type="email" id="email" class="form-control" formControlName="email">
                <p *ngIf="leadForm.get('email').invalid" class="error">*email is required</p>
                <div *ngIf="error">
                  <p class="error" style="color: red;" *ngIf="error.email">Email already exists !</p>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for="job">Occupation</label>
                <input type="text" id="job" class="form-control" formControlName="job" required>
                <p *ngIf="leadForm.get('job').invalid" class="error">*job is required</p>
              </div>
            </div>
            <div class="form-group">
              <label for="address">Address</label>
              <textarea id="address" class="form-control" rows="4" formControlName="address"></textarea>
              <p *ngIf="leadForm.get('address').invalid" class="error">*address is required</p>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="source">Source</label>
                <select class="form-control" name="source" id="source" formControlName="source">
                  <option value="walk-in">Walk in</option>
                  <option value="social">Social Media</option>
                  <option value="paper-ads">Paper Ads</option>
                  <option value="channel-partner">Channel Partner</option>
                </select>
                <p *ngIf="leadForm.get('source').invalid" class="error">*source is required</p>
              </div>
              <div class="form-group col-md-4">
                <label >Project</label>
                <select class="form-control custom-select" name="project" id="project" disabled  formControlName="project">
                  <option [value]="project._id" disabled selected>{{project.name}}</option>
                </select>
              </div>
              <div class="form-group col-md-4" *ngIf="leadForm.get('source').value !== 'channel-partner'">
                <label >Associated Sales Officer</label>
                <select class="form-control" name="sales_officer" id="sales_officer" formControlName="sale_person">
                  <option value="auto"  selected>Auto Assign</option>
                  <option [value]="sales_officer._id" *ngFor="let sales_officer of sales_officers">
                    {{sales_officer.name}}
                  </option>
                </select>
              </div>
            </div>
            <div class="row" *ngIf="leadForm.get('source').value === 'channel-partner'" >
              <div class="form-group col-md-6">
                <label for="agent">Channel Partner</label>
                <select class="form-control" name="channel_partner" id="channel_partner" formControlName="channel_partner"
                (change)="getSubBrokers(leadForm.get('channel_partner').value);">
                  <option disabled selected>Select a channel Partner</option>
                  <option [value]="item.id" *ngFor="let item of channelPartners">{{item.name}}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label >Associated Sales Officer</label>
                <p *ngIf="aso">{{aso}}</p>
              </div>
            </div>
            <div class="form-group">
              <label for="notes">Remarks</label>
              <textarea id="notes" class="form-control" rows="3" formControlName="notes"></textarea>
            </div>
            <div class="row" *ngIf="!infoFlag">
              <div class="col-12 text-center">
                <input type="submit" value="Save" class="btn btn-primary" *ngIf="!loading">

                <button class="btn btn-primary" type="button" disabled *ngIf="loading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  saving ...
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </form>
</section>
